export default __webpack_public_path__ + "static/l1-hero-img-ipad-a3fb4a23bdcc510fac85bc5a19a01408.svg";